import { Col, Icon, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const Container = styled.div`
  width: 736px;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const IconBg = styled.div`
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  width: 736px;
  height: 736px;
  top: -295px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${require('assets/branding/logo-icon-grey-10.png')});
  z-index: 1;

  @media (max-width: 1024px) {
    width: 100vw;
    height: 100vw;
    top: -110px;
  }
`;

const CircleImage = styled.img`
  width: 132px;
  width: 132px;
  z-index: 2;
`;

const ShoutOut = ({
  contentImg,
  headerText,
  subText,
  contentBg,
  contentIcon,
  iconSize,
  iconCol
}) => {
  const dispatch = useDispatch(),
    { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState);

  return (
    <Col bg="#fff" centerAll>
      <Container>
        <IconBg />

        <Col centerAll pad="0 16px" marg={isMobile ? '55px 0 0' : '120px 0 0'} zIndex={3}>
          {contentImg && <CircleImage src={contentImg} resizeMode="contain" />}

          {contentIcon && (
            <Col noFlex wid="132px" ht="132px" centerAll bg={contentBg || '#fff'}>
              <Icon type={contentIcon} dimensions={iconSize} col={iconCol} />
            </Col>
          )}
        </Col>

        <Col centerAll noFlex pad="0 24px" marg="180px 0 0">
          <Text h1 wid={!isMobile ? '426px' : 'calc(100vw - 32px)'} center>
            {t(headerText)}
          </Text>

          <Text
            center
            marg="16px 0 "
            col={theme.GREY_60}
            wid={!isMobile ? '426px' : 'calc(100vw - 32px)'}
          >
            {t(subText)}
          </Text>
        </Col>
      </Container>
    </Col>
  );
};

export default ShoutOut;
